import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d9d210d0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "BannerSettingViewContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "社区管理", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_DialogView = _resolveComponent("DialogView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "crumbs"
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      "icon-class": "house"
    }), _hoisted_2]),
    _: 1
  }), _createVNode(_component_el_row, {
    style: {
      "margin-top": "20px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      class: "primaryBtn",
      icon: "plus",
      onClick: _cache[0] || (_cache[0] = $event => $data.createVisible = true)
    }, {
      default: _withCtx(() => [_createTextVNode("添加")]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
      "table-id": "21",
      onOnFetchData: $options.onFetchData,
      initQuery: $data.initQuery
    }, {
      enable: _withCtx(data => [_createVNode(_component_el_switch, {
        "active-color": "#0078D7",
        "model-value": $data.enableMap[data.rowId],
        onChange: v => $options.enableChange(data.rowId, v)
      }, null, 8, ["model-value", "onChange"])]),
      _: 1
    }, 8, ["onOnFetchData", "initQuery"])]),
    _: 1
  })]), _createVNode(_component_DialogView, {
    "data-id": 29,
    "visible-control": $data.createVisible,
    onClose: _cache[1] || (_cache[1] = $event => $data.createVisible = false),
    onSubmit: $options.createCommunity
  }, null, 8, ["visible-control", "onSubmit"])], 64);
}